@for (_ of [].constructor(bones); track _) {
  <div class="bone">
    @if (template === 'custom') {
      <ng-content />
    } @else {
      <div class="heading"></div>
      <div class="text"></div>
      <div class="text"></div>
    }
  </div>
}
